module.exports = __webpack_public_path__ + "static/media/5f60ca4501dfc.2f56eb47.jpg";